import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: 'Pre-Purchase Advice',
      description: 'Make informed property decisions with our expert pre-purchase consultations. We assess potential properties for design feasibility and development opportunities.',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s5-bg-a.jpg'
    },
    {
      id: 2,
      title: 'Residential Design',
      description: 'Transform your vision into reality with our comprehensive residential design services. From new builds to renovations, we create beautiful living spaces.',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s5-bg-b.jpg'
    },
    {
      id: 3,
      title: 'Building Permits',
      description: 'Navigate the complex permit process with ease. Our team handles all documentation, council submissions, and approvals for your project.',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s5-bg-c.jpg'
    },
    {
      id: 4,
      title: 'Town Planning',
      description: 'Expert town planning services to guide your development through council approval processes and planning applications.',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s5-bg-d.jpg'
    },
    {
      id: 5,
      title: '3D Visualisation',
      description: 'Bring your designs to life with photorealistic 3D renders and virtual walkthroughs before construction begins.',
      image: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-m4-s5-bg-e.jpg'
    }
  ];

  return (
    <section className="services-arch04">
      <div className="services-arch04-header">
        <motion.h2 
          className="services-arch04-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Services
        </motion.h2>
      </div>

      <div className="services-arch04-grid">
        {services.map((service, index) => (
          <motion.article 
            key={service.id}
            className="service-arch04-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <Link to="/services" className="service-arch04-link">
              <div className="service-arch04-image">
                <img src={service.image} alt={service.title} />
                <div className="service-arch04-overlay" />
              </div>
              <div className="service-arch04-content">
                <h3 className="service-arch04-name">{service.title}</h3>
                <p className="service-arch04-desc">{service.description}</p>
                <span className="service-arch04-arrow">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </span>
              </div>
            </Link>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
